// Notification stage types
export type NotificationStage = "126d" | "60d" | "30d" | "14d" | "7d" | "expired" | "custom";

// Notification status types
export type NotificationStatus = "pending" | "sent" | "failed";

// Notification type
export type NotificationType = "model_expiry_warning" | "model_expired";

// Main Notification interface
export interface Notification {
  id: string;
  kai_id: string;
  kai_name: string;
  model_name: string;
  model_expiry_date: string;
  notification_stage: NotificationStage;
  notification_type: NotificationType;
  recipients: string[];
  owner_net_id: string;
  co_owner_net_ids: string[];
  status: NotificationStatus;
  sent_at: string | null;
  created_at: string;
  error_message: string | null;
  email_subject: string | null;
  email_body: string | null;
  read_at: string | null;
  read_by: string | null;
}

// Response models
export interface NotificationListResponse {
  items: Notification[];
  total: number;
  unread_count: number;
  page: number;
  page_size: number;
  total_pages: number;
}

export interface MarkAsReadResponse {
  notification_id: string;
  read_at: string;
  read_by: string;
  success: boolean;
}

export interface MarkAllAsReadResponse {
  marked_count: number;
  net_id: string;
  success: boolean;
}

// Stage color mapping for UI
export interface StageColorConfig {
  bg: string;
  text: string;
  label: string;
}

export const stageColors: Record<NotificationStage, StageColorConfig> = {
  "126d": { bg: "bg-blue-100", text: "text-blue-800", label: "126 Days" },
  "60d": { bg: "bg-cyan-100", text: "text-cyan-800", label: "60 Days" },
  "30d": { bg: "bg-yellow-100", text: "text-yellow-800", label: "30 Days" },
  "14d": { bg: "bg-orange-100", text: "text-orange-800", label: "14 Days" },
  "7d": { bg: "bg-red-100", text: "text-red-800", label: "7 Days" },
  "expired": { bg: "bg-red-200", text: "text-red-900", label: "Expired" },
  "custom": { bg: "bg-gray-100", text: "text-gray-800", label: "Custom" }
};
